/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

export const useDetectIfOverflowBottom = (ref: any, trigger: any, handler: (effect: boolean) => void) => {
  useEffect(() => {
    if (ref.current) {
      const domRect = ref.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - domRect.bottom;
      if (spaceBelow < 0) {
        handler(true);
      } else {
        handler(false);
      }
    }
  }, [trigger]);
};
